<template>
  <div class="applicant-name" layout layout-align="start-center">
    <el-tooltip placement="top" :disabled="applicant.description === undefined">
      <div class="description-tooltip" slot="content">
        <span v-if="applicant.description">{{ applicant.description }}</span
        ><span v-else>自己紹介なし</span><br /><span v-if="applicant.joinDatetime"
          >アカウント開設日: {{ formatDate(applicant.joinDatetime) }}</span
        >
      </div>
      <icon
        class="mr-x1"
        :class="{ 'border-white': isWhite }"
        :name="applicant.name || applicant.screenName"
        :pictureUrl="pictureUrl"
      ></icon>
    </el-tooltip>
    <div layout="column" layout-align="space-between">
      <span class="name" :class="{ 'text-white': isWhite }">{{ applicant.name }}</span>
      <div>
        <div>
          <a class="screen-name" v-if="disabledLink" :class="{ 'text-white': isWhite }">@{{ applicant.screenName }}</a>
          <a
            class="screen-name"
            v-else-if="snsType === 'twitter'"
            :class="{ 'text-white': isWhite }"
            :href="`https://x.com/${applicant.screenName}`"
            target="_new"
            @click="clickApplicant"
            >@{{ applicant.screenName }}</a
          >
          <a
            class="screen-name"
            v-else-if="snsType === 'instagram'"
            :class="{ 'text-white': isWhite }"
            :href="`https://instagram.com/${applicant.screenName}`"
            target="_new"
            @click="clickApplicant"
            >@{{ applicant.screenName }}</a
          >
          <a
            class="screen-name"
            v-else-if="snsType === 'tiktok'"
            :class="{ 'text-white': isWhite }"
            :href="`https://tiktok.com/@${applicant.screenName}`"
            target="_new"
            @click="clickApplicant"
            >@{{ applicant.screenName }}</a
          >
        </div>
        <div layout="row" layout-align="start-center">
          <el-tooltip v-if="applicant.isFollowing" placement="top" content="フォロー中">
            <div class="mdi mdi-check-circle"></div>
          </el-tooltip>
          <el-tooltip v-if="applicant.isSuspendedAccount" placement="top" content="凍結中">
            <div class="mdi mdi-snowflake-alert"></div>
          </el-tooltip>
          <el-tooltip
            v-if="applicant.isFollowing && applicant.isNewFollower"
            placement="top"
            content="新規獲得フォロワー"
          >
            <div class="mdi mdi-new-box"></div>
          </el-tooltip>
          <el-tooltip v-if="applicant.isPositive" placement="top" content="ポジティブ判定">
            <div class="mdi mdi-heart"></div>
          </el-tooltip>
          <el-tooltip v-if="applicant.isWarning" placement="top" content="ネガティブ判定">
            <div class="mdi mdi-alert"></div>
          </el-tooltip>
          <el-tooltip v-if="applicant.isNg" placement="top" content="NGアカウント">
            <div class="mdi mdi-cancel"></div>
          </el-tooltip>
          <el-tooltip v-if="applicant.isWebInstantwinWinner" placement="top" content="Web当選通知済み">
            <div class="mdi mdi-trophy"></div>
          </el-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.name {
  /* stylelint-disable value-no-vendor-prefix */
  display: -webkit-box;
  max-height: 18px; /* fallback */
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1; /* number of lines to show */
  line-height: 18px; /* fallback */
  /* stylelint-enable value-no-vendor-prefix */
  -webkit-box-orient: vertical;
}

.screen-name {
  font-size: $font-small-size;
  color: $sub-text-color;
}

.help-icon {
  &:hover {
    cursor: help;
  }
}

.mdi {
  width: $spacing-unit * 2;
  height: $spacing-unit * 2;
  margin: 0 0 0 2px;
  font-size: $font-large-size;
}

.mdi-check-circle {
  color: $success-color;
}

.mdi-alert {
  color: $warning-color;
}

.mdi-new-box {
  color: $danger-color;
}

.mdi-cancel {
  color: $danger-color;
}

.mdi-heart {
  color: $primary-color;
}

.mdi-trophy {
  color: $primary-color;
}

.mdi-snowflake-alert {
  color: $info-color;
}

.description-tooltip {
  max-width: $spacing-unit * 45;
  white-space: pre-wrap;
}

.border-white {
  border: 1px solid $text-color-white;
  border-radius: 50%;
}

.text-white {
  color: $text-color-white;
}
</style>
<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { defineComponent } from 'vue'

import Icon from '@/client/components/_atoms/basic_icon'
import { formatDate } from '@/client/filters/filters'
import { TrackingService } from '@/client/services'

export default defineComponent({
  components: {
    Icon
  },
  props: {
    applicant: Object,
    snsType: {
      type: String,
      default: 'twitter'
    },
    isWhite: {
      type: Boolean,
      default: false
    },
    disabledLink: {
      type: Boolean,
      default: false
    },
    screen: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isError: false
    }
  },
  created() {
    this.checkImage()
  },
  computed: {
    pictureUrl() {
      if (!this.isError && this.applicant.pictureUrl) {
        return this.applicant.pictureUrl
      }

      if (this.snsType === 'twitter') {
        return require('@/client/assets/images/twitter_default_profile.png')
      }

      if (this.snsType === 'instagram') {
        return require('@/client/assets/images/instagram_default_profile.png')
      }

      if (this.snsType === 'tiktok') {
        return require('@/client/assets/images/tiktok_default_profile.png')
      }
    }
  },
  methods: {
    formatDate,

    /**
     * 画像の読み込み
     */
    checkImage() {
      this.isError = false

      const img = new Image()

      img.onerror = () => {
        this.isError = true
      }

      img.src = this.applicant.pictureUrl
    },

    clickApplicant() {
      if (this.screen === 'シルアルコード管理') {
        TrackingService.sendEvent('click:当選メッセージの管理|シルアルコード管理|ID')
      } else if (this.screen === '応募一覧（X）') {
        TrackingService.sendEvent('click:応募一覧（X）|ユーザーID')
      } else if (this.screen === '応募一覧（IG）') {
        TrackingService.sendEvent('click:応募一覧（IG）|ユーザーID')
      } else TrackingService.sendEvent(`click:応募履歴（${this.snsType === 'twitter' ? 'X' : 'IG'}）|アカウントID`)
    }
  }
})
</script>
